import { render, staticRenderFns } from "./LeadsAccessCustomizationModal.vue?vue&type=template&id=7522d51a&scoped=true"
import script from "./LeadsAccessCustomizationModal.vue?vue&type=script&lang=js"
export * from "./LeadsAccessCustomizationModal.vue?vue&type=script&lang=js"
import style0 from "./LeadsAccessCustomizationModal.vue?vue&type=style&index=0&id=7522d51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522d51a",
  null
  
)

export default component.exports